import React, { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { EditProjectBase } from "./EditProjectBase";
import { EditLanguage } from "./EditLanguage";
import { EditGroup } from "./EditGroup";
import { EditTranslation } from "./EditTranslation";
import { EditProjectKey } from "./EditProjectKey";

import "./EditProject.scss";

const EditProject = () => {

    const [command, setCommand] = useState<string>('');

    const getEditMaks = () => {

        if (command === 'editBaseData') {
            return (<EditProjectBase></EditProjectBase>);
        }

        if (command === 'editProjectKey') {
            return (<EditProjectKey></EditProjectKey>);
        }

        if (command === 'editLanguage') {
            return (<EditLanguage></EditLanguage>);
        }

        if (command === 'editGroup') {
            return (<EditGroup></EditGroup>);
        }

        if (command === 'editTranslation') {
            return (<EditTranslation></EditTranslation>);
        }

        return (<></>);
    };


    useSelector((state: RootState) => {

        if (state.project.pageCommand !== command) {
            setCommand(state.project.pageCommand);
        }

    });


    return (<div className="editProject">
        {getEditMaks()}
    </div>);
}

export { EditProject };
